<header class="topbar" [class.disabled]="bln_editMode">
  <nav class="navbar top-navbar navbar-expand-md navbar-light">
    <!-- ============================================================== -->
    <!-- Logo -->
    <!-- ============================================================== -->
    <div class="navbar-header" style="line-height:60px">
      <a class="navbar-brand" style="line-height:55px">
        <!-- Logo icon --><b>
          <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
          <!-- Dark Logo icon -->
          <!-- <img src="assets/images/ic.png" alt="homepage" class="dark-logo" style="height:50px;width:50px"/> -->
          <!-- Light Logo icon -->
        </b>
        <!--End Logo icon -->
        <!-- Logo text --><span>
          <!-- dark Logo text -->
          <img [src]="logo" alt="Homepage" class="dark-logo clickable-logo" style="height: 30px;" (click)="goHome()" />

          <!-- Light Logo text -->
        </span> </a>
    </div>
    <!-- ============================================================== -->
    <!-- End Logo -->
    <!-- ============================================================== -->
    <div class="navbar-collapse">
      <!-- ============================================================== -->
      <!-- toggle and nav items -->
      <!-- ============================================================== -->
      <ul class="navbar-nav me-auto mt-md-0">
        <!-- This is  -->

        <li class="nav-item m-l-10">
          <a class="nav-link sidebartoggler text-muted waves-effect waves-dark" href="javascript:void(0)"
            (click)="userService.toggleNavigation()">
            <i class="ti-menu"></i>
          </a>
        </li>
      </ul>
      <!-- ============================================================== -->
      <!-- User profile and search -->
      <!-- ============================================================== -->

      <ul class="navbar-nav my-lg-0">
        <li class="nav-item dropdown" ngbDropdown #myDrop="ngbDropdown" placement="bottom-right">
          <a ngbDropdownToggle class="nav-link dropdown-toggle text-muted waves-effect waves-dark"
            href="javascript:void(0)">
            Welcome, {{userName}}
            <span class="mdi mdi-chevron-down"></span>
          </a>

          <div class="dropdown-menu dropdown-menu-left animated slideInDown me-2" ngbDropdownMenu
            style="left: -40px; right: inherit; width: -webkit-fill-available;">
            <ul class="dropdown-user">
              <!-- <li *ngIf="bln_idAdmin==1" (click)="changeProfile(); myDrop.close()">
          <a style="text-decoration: none;"><i class="fa fa-key"></i> Change Profile</a>
        </li> -->

              <li (click)="viewProfile(); myDrop.close()">
                <a style="text-decoration: none;"><i class="ti-user"></i> View Profile</a>
              </li>

              <!-- <li *ngIf="bln_isLdap!=1">
          <a routerLink="/changePassword" (click)="myDrop.close()" style="text-decoration: none;">
            <i class="fa fa-key"></i> Change Password
          </a>
        </li> -->

              <li (click)="logOut(); myDrop.close()">
                <a href="#" style="text-decoration: none;"><i class="fa fa-power-off"></i> Logout</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>

    </div>
  </nav>
</header>